﻿const buttons = document.querySelectorAll('[data-show-password]');

buttons.forEach(button => {
  let options = JSON.parse(button.dataset.showPassword);
  let input = document.querySelector(options.targetSelector);
  button.addEventListener('mouseenter', function (e) {
	input.type = "text";
  });
  button.addEventListener('mouseleave', function (e) {
	input.type = "password";
  });
});